var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-lesson-quiz-list"},[_c('carousel',{attrs:{"per-page-custom":[
      [200, 1.2],
      [400, 2.2],
      [768, 3.5],
      [992, 4.5],
      [1500, 4.8]
    ],"pagination-enabled":false,"navigation-enabled":"","navigation-next-label":"<i class='icon-chevron-right'></i>","navigation-prev-label":"<i class='icon-chevron-left'></i>","mouse-drag":false}},_vm._l((_vm.items),function(item,i){return _c('slide',{key:i,staticClass:"pr-4"},[_c('lesson-quiz-item',{attrs:{"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }